// Module
var code = "<div id=\"content\">\n    <h2>분석 중...</h2>\n    <p>\"{{ config.tokenizer }}\" (으)로 \"{{ config.document.title }}\" 을(를) 분석하고 있습니다.</p>\n</div>";
// Exports
module.exports = code;